export function emptyFn() {}

export function doNothing(arg) {
  return arg;
}
